module.exports = __webpack_public_path__ + "img/AD-HANOI_5.7ac23846.jpg";